<template>
  <div class="container sv030">
    <BreadcrumbGroup :items="breadcrumbItems" />

    <HeadingOne>会員規約一覧</HeadingOne>

    <section class="_mb-md-120 _mb-sm-60">
      <ListGroup class="-link">
        <ListItem
          class="-link"
          href="/static/pdf/sv/importantnoticefromKDDI.pdf"
          target="_blank"
        >
          <HeadingIcon class="-left _mb-0">
            KDDI・沖縄セルラーからの重要なお知らせ（個人情報の提供について）<IconBox
              src="pdf"
              class="-xs _ml-5"
            ></IconBox>
          </HeadingIcon>
        </ListItem>
        <ListItem
          class="-link"
          href="/static/pdf/sv/membershipcontract.pdf"
          target="_blank"
        >
          <HeadingIcon class="-left _mb-0">
            au PAY スマートローン会員規約<IconBox
              src="pdf"
              class="-xs _ml-5"
            ></IconBox>
          </HeadingIcon>
        </ListItem>
        <ListItem
          class="-link"
          href="/static/pdf/sv/termsofserviceuse.pdf"
          target="_blank"
        >
          <HeadingIcon class="-left _mb-0">
            WEBおよびスマートフォン専用アプリケーションサービス利用規定<IconBox
              src="pdf"
              class="-xs _ml-5"
            ></IconBox>
          </HeadingIcon>
        </ListItem>
      </ListGroup>
    </section>
  </div>
  <!-- container -->
</template>

<script>
import { setMeta } from "@/utils/Meta";
import BreadcrumbGroup from "@/components/breadcrumb/BreadcrumbGroup";
import HeadingOne from "@/components/heading/HeadingOne";
import ListGroup from "@/components/list/ListGroup";
import ListItem from "@/components/list/ListItem";
import HeadingIcon from "@/components/heading/HeadingIcon";
import IconBox from "@/components/icons/IconBox";

export default {
  name: "Sv030",
  components: {
    BreadcrumbGroup,
    HeadingIcon,
    IconBox,
    ListItem,
    ListGroup,
    HeadingOne,
  },
  setup() {
    setMeta({
      title: "会員規約一覧",
      description:
        "au PAY スマートローンの会員規約などをご案内します。au PAY スマートローンはau IDをお持ちのお客様のための便利なカードレスローンサービスです。お申込みは、スマートフォン・パソコンでかんたんWEB完結！24時間お申込み可能。最短30分で審査結果をご連絡します。",
      keywords:
        "au PAY スマートローン,au,カードレスローン,スマートフォン,au PAY 残高,セブン銀行スマホATM,借入,返済,手続き,会員,会員規約",
    });
  },
  data() {
    return {
      breadcrumbItems: [
        {
          text: "トップ",
          routerName: "root",
        },
        {
          text: "会員規約一覧",
          active: true,
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/stylesheets/styles";
</style>
